import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Solución para el problema del padding-right
document.addEventListener('DOMContentLoaded', () => {
  // Crear una hoja de estilo para anular el comportamiento
  const styleSheet = document.createElement('style');
  styleSheet.textContent = `
    body {
      padding-right: 0 !important;
      overflow-y: scroll !important;
    }
    
    .MuiModal-root .MuiBackdrop-root,
    .MuiPopover-root .MuiBackdrop-root,
    .MuiDialog-root .MuiBackdrop-root {
      width: 100% !important;
    }
  `;
  document.head.appendChild(styleSheet);
  
  // Observar cambios en el estilo del body
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.attributeName === 'style') {
        document.body.style.paddingRight = '0px';
      }
    }
  });
  
  observer.observe(document.body, { attributes: true });
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
